import _ from "lodash";
import alt from "../alt";
import { PageAction } from "../actions";
import { Organization } from "../models";
import { List } from "immutable";

class UnWrappedPageStore {
  /**
   * @constructor
   */
  constructor() {
    /**
     * Site title
     * @type {String|null}
     */
    this.siteTitle = null;

    /**
     * Assets href (Absolute path)
     * @type {String|null}
     */
    this.themeHref = null;
    /**
     * Href of root
     * @type {String|null}
     */
    this.baseHref = null;
    /**
     * Facebook URL
     * @type {String}
     */
    this.FacebookURL = null;
    /**
     * Instagram URL
     * @type {String}
     */
    this.InstagramURL = null;
    /**
     * Linkedin URL
     * @type {String}
     */
    this.LinkedinURL = null;
    /**
     * Button under the logo.
     * @type {List<NavItem>}
     */
    this.navShortcuts = new List();

    /**
     * Creation date
     * @type {Date}
     */
    this.created_at = new Date();

    /**
     * Last edited date
     * @type {Date}
     */
    this.updated_at = new Date();

    /**
     * Last publication date
     * @type {Date}
     */
    this.published_at = new Date();

    /**
     * Actual language in ISO-8601
     * @type {String|null}
     */
    this.language = null;

    /**
     * Current page title.
     * @type {String|null}
     */
    this.pageTitle = null;

    /**
     * Organization details, like name and address
     * @type {Organization}
     */
    this.organization = new Organization();
    /**
     * ALl the pages by types.
     * ```
     * this.props.stores.pages.HomePage.first(); // Give first homepage
     * this.props.stores.pages.ExperiencePage.map();
     * ```
     * @type {Object<String, List>}
     */
    this.pages = {};

    /**
     * Navigation links
     * @type {List<NavItem>}
     */
    this.navigation = new List();
    this.bindActions(PageAction);
  }

  /**
   * Initialize the store with all the values
   * that our api give.
   * @param  {Object} storeSnapshot
   */
  onInit(storeSnapshot) {
    _.forEach(storeSnapshot, (value, key) => {
      this[key] = value;
    });
  }
}

UnWrappedPageStore.config = {
  /**
   * Called when Alt receive a bootstrap
   * @param  {Object} data
   * @return {Object}      De-serialized data.
   */
  onDeserialize: (data) => {
    return data;
  },
};

/**
 * Use with PageStore.getPage(2) for page#2.
 *
 * @param  {Number} pageID Page id you are looking for
 * @return {Model|null}        The page model associate to your page ID. Like HomePage.
 *                                 Return null if not found.
 */
UnWrappedPageStore.getPage = (pageID) => {
  const matches = _.map(this.getState().pages, (pageList, key) => {
    const result = pageList.findEntry(
      (pageModel) => pageModel.ID === pageID,
      null,
      [-1, false]
    );
    return result;
  })
    .filter((match) => _.last(match))
    .map((match) => _.last(match));
  const result = _.first(matches);
  if (_.isNil(result)) return null;
  return result;
};
export default alt.createStore(UnWrappedPageStore, "PageStore");



// WEBPACK FOOTER //
// ./src/stores/PageStore.js